import type { Request } from '../../../index';
import type { VendingMachineKind } from 'app/dataTypes/vending/MachineKind.types';
import type { Machine } from './get';


export type Result = Machine

export type Params = {
  title: string,
  number: string,
  model_id: number,
  version_id: number,
  kind: VendingMachineKind,
  school_id: number,
  building_id: number,
  sale_point_id: number,
  deleted?: boolean,
}

type UrlParams = {
  machineId: number | string,
}

export const PUT_VENDING_MACHINES: Request<Params, Machine, UrlParams> = [
  'data/vending/machines/{machineId}',
  'put',
  ['data', 'data'],
];
